<template>
    <rkm-area
        no-margin-top
        :title="title ? title : 'Glicemia capilar'"
    >
        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => data.valor"
                    append-text="mg/dL"
                    label="Glicemia capilar"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.momentoColeta.nome"
                    label="Momento da coleta"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        data: {type: Object},
        title: {type: String, default: null},
    },
}
</script>